<template>
    <div>
        <Modal size="md" @close="$emit('close')">
            <template #header>
                <div class="text-gray-600">Import Template from JSON</div>
            </template>

            <template #body>
                <div class="p-6">
                    <DragAndDropImportInput @file-added="setDefinition" />
                </div>
            </template>

            <template #footer>
                <div class="flex justify-between border-t border-gray-200 p-6">
                    <AtomicButton
                        color="white"
                        size="md"
                        data-cy="plugin-settings-update-domains-cancel"
                        @click="$emit('close')"
                    >
                        Cancel
                    </AtomicButton>

                    <AtomicButton
                        size="md"
                        color="yellow"
                        :disabled="
                            selectedDefinition === '' ||
                            selectedDefinition === undefined ||
                            loading
                        "
                        type="submit"
                        lock-message="You need a Plugin subscription (Plugin Expansion or higher) to use this feature."
                        @click="handleImport"
                    >
                        Import
                    </AtomicButton>
                </div>
            </template>
        </Modal>
    </div>
</template>

<script lang="ts" setup>
import DragAndDropImportInput from '@/components/Atomic/Inputs/DragAndDropImportInput.vue';

const { importTemplate } = useTemplates();

const emit = defineEmits(['close']);

const selectedDefinition = ref<string>('');
const loading = ref<boolean>(false);

const handleImport = async () => {
    loading.value = true;
    await importTemplate(selectedDefinition.value);
    loading.value = false;
    emit('close');
};

const setDefinition = (definition: string) => {
    selectedDefinition.value = definition;
};
</script>

<style></style>
